import React, { useContext, useEffect, useState } from "react";
import ConectaZapDeviceIcon from "../../../components/icons/ConectaZapDeviceIcon";
import StatusCircle from "./StatusCircle";
import StatusText from "./StatusText";
import { Button, CircularProgress } from "@material-ui/core";

import { GlobalContext } from "../../../contexts/GlobalContext";
import {
  getQrCode,
  disconnectPhoneFromInstance,
} from "../../../repositories/portal_api/ConectaZap";
import { notify } from "../../../utils/notify";
import { Refresh } from "@material-ui/icons";
import { ContainerRefreshQrCode } from "../styles/ConectaZapPage";

const DeviceConnect = ({
  instance,
  updateInstanceConnection,
  setLoadingPage,
  ...props
}) => {
  const { companyUser } = useContext(GlobalContext);

  const [imgQrCode, setImgQrCode] = useState("");
  const [loadingQrCode, setLoadingQrCode] = useState(true);

  const [qtQrCodeCallings, setQrCodeCallings] = useState(0);
  const [qrCodeIntervalId, setQrCodeIntervalId] = useState(null);

  useEffect(() => {
    if (instance.status === "connected") {
      clearInterval(qrCodeIntervalId);
      setImgQrCode("");
    }

    if (imgQrCode) {
      if (qtQrCodeCallings > 2) {
        clearInterval(qrCodeIntervalId);
        setImgQrCode("");
      }
      setQrCodeCallings((prevQtQrCodeCallings) => prevQtQrCodeCallings + 1);
    }

    // eslint-disable-next-line
  }, [instance, imgQrCode]);

  useEffect(() => {
    async function getQrCodeResponse() {
      const response = await getQrCode(companyUser.document, instance.id);

      if (response?.success) {
        setImgQrCode(response?.data?.data?.value);
      } else {
        setQrCodeCallings(3);
        clearInterval(idInterval);
      }

      if (response?.data?.data?.connected) {
        clearInterval(idInterval);
      }

      setLoadingQrCode(false);
    }

    getQrCodeResponse();

    const idInterval = setInterval(getQrCodeResponse, 15000);
    setQrCodeIntervalId(idInterval);

    return () => {
      clearInterval(idInterval);
    };
    // eslint-disable-next-line
  }, []);

  async function restartIntervalQrCode() {
    setLoadingQrCode(true);
    setQrCodeCallings(0);
    async function getQrCodeResponse() {
      const response = await getQrCode(companyUser.document, instance.id);

      if (response?.success) {
        setImgQrCode(response?.data?.data?.value);
      } else {
        setQrCodeCallings(3);
        clearInterval(idInterval);
      }

      setLoadingQrCode(false);
    }

    await getQrCodeResponse();

    const idInterval = setInterval(getQrCodeResponse, 15000);
    setQrCodeIntervalId(idInterval);
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: 16,
        paddingRight: 16,

        height: "100%",
      }}
    >
      {loadingQrCode ? (
        <CircularProgress></CircularProgress>
      ) : instance.status !== "connected" && imgQrCode ? (
        <img
          src={imgQrCode}
          alt="QR Code"
          style={{
            width: 200,
            height: 200,
            marginBottom: 16,
          }}
        />
      ) : imgQrCode === "" && qtQrCodeCallings > 2 ? (
        <ContainerRefreshQrCode onClick={restartIntervalQrCode}>
          <Refresh style={{ color: "#616161", marginTop: 16 }}></Refresh>

          <div style={{ color: "#616161", fontSize: 11 }}>Gerar novo</div>
          <div
            style={{
              marginTop: 8,
              color: "#424242",
              fontWeight: 500,
              fontSize: 9,
            }}
          >
            QR Code expirado
          </div>
        </ContainerRefreshQrCode>
      ) : (
        <ConectaZapDeviceIcon />
      )}

      <div
        style={{
          marginTop: 24,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <StatusCircle status={instance.status} />
        <StatusText status={instance.status} />
      </div>

      {instance.status === "connected" && (
        <Button
          style={{
            background: "#F0F1F3",
            textTransform: "none",
            marginTop: 16,
            color: "#364461",
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 24,
            paddingRight: 24,
          }}
          onClick={async () => {
            setLoadingPage(true);
            try {
              const response = await disconnectPhoneFromInstance(
                companyUser.document,
                instance.id
              );

              if (response?.success) {
                notify("Desconectado com sucesso", true, "success");
                updateInstanceConnection(instance.id, false);
                restartIntervalQrCode();
              }
            } catch (e) {
              notify("Erro ao desconectar", true, "error");
            } finally {
              setLoadingPage(false);
            }
          }}
        >
          Desconectar
        </Button>
      )}
    </div>
  );
};

export default DeviceConnect;
